import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgCalendar(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.75 19C7.75 18.3096 8.30964 17.75 9 17.75H11C11.6904 17.75 12.25 18.3096 12.25 19L12.25 21C12.25 21.6904 11.6904 22.25 11 22.25H9C8.30964 22.25 7.75 21.6904 7.75 21V19Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.25 4.75V2.75H9.75V4.75L4 4.75C3.30964 4.75 2.75 5.30964 2.75 6L2.75 28C2.75 28.6904 3.30964 29.25 4 29.25L28 29.25C28.6904 29.25 29.25 28.6904 29.25 28L29.25 6C29.25 5.30964 28.6904 4.75 28 4.75H22.25V2.75L19.75 2.75V4.75L12.25 4.75ZM19.75 9.25V7.25L12.25 7.25L12.25 9.25L9.75 9.25V7.25L5.25 7.25L5.25 12.75L26.75 12.75V7.25H22.25V9.25H19.75ZM5.25 15.25L5.25 26.75L26.75 26.75V15.25L5.25 15.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
